// extracted by mini-css-extract-plugin
export default {"container-btn":"ButtonsPages_container-btn__TzQ4E","button":"ButtonsPages_button__JtsT4"};